import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import { useAuth } from '~/hooks/useAuth';
import keycloak from '~/shared/guards/Keycloak';

export function LoginPage() {
  const { initialized, isAuthenticated } = useAuth();

  useEffect(() => {
    if (initialized && !isAuthenticated) {
      keycloak.login();
    }
  }, [initialized, isAuthenticated]);

  if (initialized && isAuthenticated) {
    return <Navigate to="/app/dashboard" replace />;
  }

  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', p: 2 }}>
      <Paper sx={{ width: '100%', maxWidth: 460, p: 4, borderRadius: 3 }}>
        <Stack spacing={2}>
          <Typography variant="h5" sx={{ fontWeight: 900 }}>
            Sign in
          </Typography>
          <Typography variant="body2" color="text.secondary">
            You’ll be redirected to continue.
          </Typography>
          <Button variant="contained" onClick={() => keycloak.login()} sx={{ borderRadius: 2 }}>
            Continue to login
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
}
